window.addEventListener('load', () => {
  const hook = setInterval(() => {
    const hulkForms = document.querySelectorAll('.pxFormGenerator');
    let loadError = false;
    if (!hulkForms) clearInterval(hook);
    hulkForms.forEach((formDiv) => {
      if (!formDiv.querySelector('iframe') || !formDiv.querySelector('.form_generater_form_div')) {
        loadError = true;
      }
    })
    if (loadError && typeof window.GetCorePage === 'function') {
      GetCorePage();
      clearInterval(hook);
    } else if (!loadError){
      clearInterval(hook);
    }
  },250);
  setTimeout(()=>{
    clearInterval(hook);
  },5000)
})


